import { render } from "./CommonHeader.vue?vue&type=template&id=7983c69c&scoped=true"
import script from "./CommonHeader.vue?vue&type=script&lang=js"
export * from "./CommonHeader.vue?vue&type=script&lang=js"

import "./CommonHeader.vue?vue&type=style&index=0&id=7983c69c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7983c69c"]])

export default __exports__